import type { DashboardFilters } from '@oxxean/types';
import type { TableState } from '../../hooks/useTableState';

export type QueryParams = Record<string, string | number | boolean | undefined>;

/** Serializa los filtros globales descartando los valores vacíos. */
export function filtersToParams(filters: DashboardFilters): QueryParams {
  const params: QueryParams = {};
  (Object.keys(filters) as Array<keyof DashboardFilters>).forEach((key) => {
    const value = filters[key];
    if (value === undefined || value === null || value === '') return;
    params[key] = value;
  });
  return params;
}

export function tableStateToParams(state: TableState): QueryParams {
  const params: QueryParams = { page: state.page, pageSize: state.pageSize };
  if (state.sortBy) {
    params.sortBy = state.sortBy;
    params.sortDir = state.sortDir;
  }
  if (state.search.trim().length > 0) params.search = state.search.trim();
  return params;
}
